import { define, type } from 'type-r';
import Collection from './base'
import Product from './product'
import ProductVariant, {ProductVariantCollection} from './product_variant'

@define
export class ProductVariableCollection<R extends ProductVariable = ProductVariable> extends Collection<R> {
    static comparator = 'order'
}

@define
export default class ProductVariable extends Product {
    static Collection = ProductVariableCollection<ProductVariable>;
    @type(ProductVariantCollection).as variants: ProductVariantCollection
    @type(String).as selectedVariant: string
    @type(Number).as order: number
    
    get selected():ProductVariant {
        if (this.selectedVariant)
	    return this.variants.get(this.selectedVariant);
        return null;
    }
    set selected(v:string|ProductVariant|number) {
        if (typeof v == 'string' || typeof v == 'number') {
            var mdl:ProductVariant = this.variants.get(v.toString());
            if (mdl)
                this.selectedVariant = mdl.pid.toString();
            else
                this.selectedVariant = null;
        }
        else {
            this.selectedVariant = v.pid.toString();
        }        
    }
    
    get defprod() {
	return this.variants.find(function(v) {
	    return v.default;
	});
    }
    
    initialize(atts:any, opts:any) {
        super.initialize(atts, opts);
	this.on("change:selectedVariant", this.chooseProduct, this);	
    }
    
    chooseProduct() {
	this.trigger("choose_product", this.selectedVariant);
    }
    
    toJSON(opts?:any) {
	var data = super.toJSON(opts);
	data.selected = this.selected ? this.selected.toJSON() : undefined;
	data.defprod = this.defprod ? this.defprod.toJSON() : undefined;
	return data;
    }    
}
